
import React from "react";
import { CreditCard, CalendarDays } from "lucide-react";
import { formatDate, formatPrice } from "../utils";

interface SubscriptionDetailsProps {
  price: number;
  startDate: string;
  endDate: string | null;
}

export function SubscriptionDetails({ price, startDate, endDate }: SubscriptionDetailsProps) {
  return (
    <div className="space-y-1 text-sm">
      <div className="flex items-center gap-2 text-gray-600">
        <CreditCard className="h-4 w-4" />
        <span>{formatPrice(price)}</span>
      </div>
      
      <div className="flex items-center gap-2 text-gray-600">
        <CalendarDays className="h-4 w-4" />
        <span>Started on {formatDate(startDate)}</span>
      </div>
      
      {endDate && (
        <div className="flex items-center gap-2 text-gray-600">
          <CalendarDays className="h-4 w-4" />
          <span>Ends on {formatDate(endDate)}</span>
        </div>
      )}
    </div>
  );
}
